export const ADD_DICE_ROLL_RECORD = "ADD_DICE_ROLL_RECORD"
export const CLEAR_DICE_ROLL_HISTORY = "CLEAR_DICE_ROLL_HISTORY"
export const ADD_PLAYER = "ADD_PLAYER"
export const UPDATE_PLAYER = "UPDATE_PLAYER"
export const DELETE_PLAYER = "DELETE_PLAYER"
export const SET_ACTIVE_PLAYER = "SET_ACTIVE_PLAYER"
export const UPDATE_PLAYER_CONTROLS = "UPDATE_PLAYER_CONTROLS"
export const UPDATE_CONTROL_CONFIG = "UPDATE_CONTROL_CONFIG"
export const UPDATE_PLAYER_DICE = "UPDATE_PLAYER_DICE"
export const SET_ROLLING_STATE = 'SET_ROLLING_STATE'